'use client';

import { useBoardDetailQuery } from '@module/queries/customer/customerQueryHooks';
import { convertISOToDottedShortDateString } from '@module/utils/date/convertDateFormat';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import './custom.css';

interface Props {
  noticeIdx?: number;
}

function CustomerNoticeDetailContainer({ noticeIdx: noticeIdxProp }: Props) {
  const router = useRouter();
  const params = useParams<{ idx: string }>();
  const resolvedNoticeIdx = noticeIdxProp ?? Number(params?.idx ?? '');
  const isValidNoticeIdx = Number.isFinite(resolvedNoticeIdx);

  useEffect(() => {
    if (!isValidNoticeIdx) {
      router.push('/customer/notice');
    }
  }, [isValidNoticeIdx, router]);

  const { data: detailData } = useBoardDetailQuery(
    {
      idx: resolvedNoticeIdx,
    },
    { enabled: isValidNoticeIdx },
  );

  if (!isValidNoticeIdx || !detailData) return null;

  return (
    <div className='pt-10'>
      <div>
        <h2 className='mb-2.5 font-bold text-2xl text-baseFg'>
          {detailData.data.importantYN === 'Y' && <span className='mr-1.5 whitespace-nowrap text-[#ef312a]'>필독</span>}
          {detailData?.data.subject}
        </h2>
        <p className='mb-6 text-colorFg18'>
          <span>{convertISOToDottedShortDateString(detailData.data.insertDateTime)}</span>
        </p>
        <div className='my-6 border-y border-y-borderBg05 py-[30px] text-colorFg18'>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: detailData.data.contents }} />
          {detailData.data.imgMainSrc && <img src={detailData.data.imgMainSrc} alt='addedimg' />}
        </div>
      </div>
      <div className='mt-20 flex justify-center'>
        <BaseButton size='md' className='min-w-[112px]' onClick={() => router.push('/customer/notice')}>
          목록
        </BaseButton>
      </div>
    </div>
  );
}

export default CustomerNoticeDetailContainer;
